import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BoardResponseModel } from 'src/app/model/BoardResponseModel';
import { DashboardResponseModel } from 'src/app/model/DashboardResponseModel';
import { InvoiceDetailsResponseModel } from 'src/app/model/InvoiceDetailsResponseModel';
import { InvoiceTrackingResponseModel } from 'src/app/model/InvoiceTrackingResponseModel';
import { Page } from 'src/app/model/Page';
import { TenementExchangeModel } from 'src/app/model/TenementExchangeModel';
import { ApiUrls } from 'src/app/services/ApiUrls';
import { MasterService } from 'src/app/services/master.service';
import { InvoiceModal } from '../invoice-modal/invoice-modal';
import { InvoiceStageModel } from 'src/app/model/InvoiceStageModel';
import { InvoiceNoStageCountModel } from 'src/app/model/InvoiceNoStageCountModel';


@Component({
  selector: 'app-secure-invoice-tracking',
  templateUrl: './generated-invoice-view.component.html',
  styleUrls: ['./generated-invoice-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GeneratedInvoiceView implements OnInit {
  
  page: Page<InvoiceStageModel>;
  dataSource: MatTableDataSource<InvoiceStageModel> = new MatTableDataSource();
  dataSourcesCnt: MatTableDataSource<InvoiceNoStageCountModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  boardList: {[key:number]:string};

  public lotteryList: {[key:number]:string};

  public schemeList: {[key:number]:string};
  isSubmitDisabled: boolean = false;

  stageValue: number;
  isLoadingAfterSave = false;

  boardKey: number;
  selectAllChecked: boolean = false;
  lotteryKey: number;
  data: InvoiceStageModel;
  key: number;
  applicationId: number;
  stage_no: number;
  invoiceNo: string;
  tenementId: number;
  invoiceStatus: string;
  stageCount : InvoiceNoStageCountModel;
  // selectedElement: InvoiceTrackingResponseModel | null = null;
  selectedElements: InvoiceStageModel[] = [];

  // selectedElement: InvoiceTrackingResponseModel | null = null;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  displayedColumns: string[] = [
    "id",
    "schemeCode",
    "tenementDetails",
    "applicationNo",
    "name",
    "drawStatus",
    "currentStage",
    "invoiceNo"
  ];
  
  count: any;
  formGroup: any;
  dialogRef: any;
  http: any;

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private modalCtrl: ModalController,
    private route: ActivatedRoute,
    //private router: Router,
    private _snackBar: MatSnackBar) { }

  ngOnInit(): void {

    this.route.params.subscribe((params: Params) => {
      this.invoiceNo = params["invoiceNo"];
      
    });

    this.onLoad();

    this.filterForm = new FormGroup({
      boardFilter: new FormControl(null, [Validators.required]),
      lotteryFilter: new FormControl(null, [Validators.required]),
      stageNumberFilter: new FormControl(null, [Validators.required]),
      stageStatusFilter: new FormControl(null, [Validators.required]),
    });
  }

  

  onLoad() {
    this.isLoading = true;
    console.log("invoiceNo before formatting>>>>",this.invoiceNo)
    // let formattedInvoiceNo1 = this.formatInvoiceNumber(this.invoiceNo);
    console.log("InvoiceNo1",this.invoiceNo); 
    this.countofInvoice();

    this.masterService.fetchInvoiceDetailView(this.currentPage,this.pageSize,this.invoiceNo).subscribe((data) => {
      console.log(data);
      this.isLoading = false;
      this.page=data;
      this.dataSource = new MatTableDataSource(this.page.content);
      console.log("dataSource >>>> ",this.dataSource);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = this.page.totalElements;
      });
    },
    (error) => {
      console.log(error);
      this.isLoading = false;
      // this.isSearchDisabled = false;
  });

  }
  
  async countofInvoice(){
    //let formattedInvoiceNo1 = this.formatInvoiceNumber(this.invoiceNo);
    //console.log("formattedInvoiceNo1",formattedInvoiceNo1);
       this.masterService.countByInvoice(this.invoiceNo).subscribe((data) => {
        console.log(data);
        // this.isLoading = false;
        console.log("stage count>>>>", this.stageCount);
        this.stageCount = data;
        // this.dataSourcesCnt = new MatTableDataSource(data.)
        
       });
  }
 
  updateSubmitButtonStatus() {
    this.isSubmitDisabled = this.selectedElements.length === 0;
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if(status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if(status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if(status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  showObj(o1: any, o2: any) {    
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }
  

async errorToast(errorMessage: string, dur?: number) {
  await this._snackBar.open(errorMessage, "Close", {
    horizontalPosition: "right",
    verticalPosition: "top",
    panelClass: "error-toast",
    duration: dur ? dur : 3 * 1000,
  });
}
async successToast() {
  await this._snackBar.open("", "Close", {
    horizontalPosition: "right",
    verticalPosition: "top",
    panelClass: "success-toast",
    duration: 3 * 1000,
  });
}

// private formatInvoiceNumber(invoiceNo: string): string {
//   if (invoiceNo.includes('/')) {
//       return invoiceNo.replace('/', '^^');
//   }
//   return invoiceNo;
// }


}
